import api from './axiosInstance';

interface UserInfo {
  firstName?: string;
  lastName?: string;
  email: string;
  phone: string;
  deliveryAddress?: string;
  newsletter: boolean;
}

interface UpdateUserInfoDto {
  firstName?: string;
  lastName?: string;
  phoneNumber: string;
  deliveryAddress?: string;
  newsletter: boolean;
}

export const identityApi = {
  getUserInfo: async (): Promise<UserInfo> => {
    const response = await api.get('identity');
    return response.data;
  },

  updateUserInfo: async (dto: UpdateUserInfoDto): Promise<void> => {
    await api.patch('identity/update', dto);
  }
}; 